__turbopack_context__.v({
  "groupCardBody": "odnYGW_groupCardBody",
  "groupCardButton": "odnYGW_groupCardButton",
  "groupCardHand": "odnYGW_groupCardHand",
  "groupCardHeader": "odnYGW_groupCardHeader",
  "groupCardPreviewFallback": "odnYGW_groupCardPreviewFallback",
  "groupGrid": "odnYGW_groupGrid",
  "groupHandCard": "odnYGW_groupHandCard",
  "groupHandCardBack": "odnYGW_groupHandCardBack",
  "groupHandCardFront": "odnYGW_groupHandCardFront",
  "groupHandCardMiddle": "odnYGW_groupHandCardMiddle",
  "groupHandCardSlot": "odnYGW_groupHandCardSlot",
  "groupModalCardName": "odnYGW_groupModalCardName",
  "groupModalContent": "odnYGW_groupModalContent",
  "groupModalCopy": "odnYGW_groupModalCopy",
  "groupModalDescription": "odnYGW_groupModalDescription",
  "groupModalHeader": "odnYGW_groupModalHeader",
  "groupModalLabel": "odnYGW_groupModalLabel",
  "groupModalPreview": "odnYGW_groupModalPreview",
  "groupModalResults": "odnYGW_groupModalResults",
  "groupModalTitle": "odnYGW_groupModalTitle",
});
